var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_vm.$ct("peppol-title")))]),
      _c("p", { staticClass: "peppol-info" }, [
        _vm._v(_vm._s(_vm.$ct("peppol-info"))),
      ]),
      _c(
        "w-row",
        { attrs: { stretch: "" } },
        [
          _c(
            "w-col",
            { attrs: { sm: "12" } },
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("company-name-label"), fancy: "" },
                model: {
                  value: _vm.companyName,
                  callback: function ($$v) {
                    _vm.companyName = $$v
                  },
                  expression: "companyName",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { sm: "12" } },
            [
              _c("w-input", {
                staticClass: "mts",
                attrs: { label: _vm.$ct("vat-no-label"), fancy: "" },
                model: {
                  value: _vm.vatNumber,
                  callback: function ($$v) {
                    _vm.vatNumber = $$v
                  },
                  expression: "vatNumber",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { staticClass: "mts", attrs: { sm: "12" } },
            [
              _c("w-radio", {
                attrs: {
                  checked: _vm.sendAndReceive == 1,
                  label: _vm.$ct("peppol-send-and-receive"),
                },
                on: {
                  input: function ($event) {
                    _vm.sendAndReceive = 1
                  },
                },
              }),
              _c("w-radio", {
                attrs: {
                  checked: _vm.sendAndReceive == 0,
                  label: _vm.$ct("peppol-send-only"),
                },
                on: {
                  input: function ($event) {
                    _vm.sendAndReceive = 0
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticClass: "mt" },
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.prev()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.back")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "cancel",
              style: { marginRight: "5px" },
              attrs: { disabled: _vm.controlsDisabled },
              on: {
                click: function ($event) {
                  return _vm.skip()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("peppol-later")) + " ")]
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.controlsDisabled || !_vm.isFormValid },
              on: {
                click: function ($event) {
                  return _vm.activate()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("peppol-activate")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }